export default "__VITE_ASSET__BS7nu0rf__"